import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSingleProductbystatus } from "../../../../actions/singleProductAction";
import { getAllCategory } from "../../../../actions/categoryAction";
import { getAllLocation } from "../../../../actions/warehouseAction";
import { getAllAttribute } from "../../../../actions/attributeAction";
import RenderTable from "./RenderTable";
import ActiveRenderTable from "./ActiveRendertable";
import { LoadingOutlined } from "@ant-design/icons";
import {
  Skeleton,
  Tabs,
  Row,
  Col,
  AutoComplete,
  Divider,
  TreeSelect,
  Spin,
  Select,
  DatePicker,
} from "antd";
const { Option } = Select;
const { RangePicker } = DatePicker;

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ProductList = ({
  getSingleProductbystatus,
  List,
  updatelist,
  setUpdatelist,
  setselectedproduct,
  totalitems,
  getAllCategory,
  categoryList,
  Location,
  getAllAttribute,
  attributelist,
}) => {
  const [data, setdata] = useState(false);
  const [products, setproducts] = useState(false);
  const loading = useRef(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const keytab = useRef(true);
  const keyward = useRef("");
  const searchCategory = useRef("");
  const searchColor = useRef("");
  const livestart = useRef("2024-01-01T00:00:00");
  const liveend = useRef("");
  const searchLocation = useRef("");
  const [reload, setreload] = useState(false);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  function callback(key) {
    console.log(key);
    pageno.current = 1;
    if (key == 1) {
      keytab.current = true;
    } else {
      keytab.current = false;
    }
    setreload(true);
  }

  useEffect(() => {
    getAllAttribute();
    getAllCategory();
    getAllLocation();
    getSingleProductbystatus(
      keytab.current,
      keyward.current,
      searchCategory.current,
      searchColor.current,
      "",
      pageno.current,
      page_size.current,
      "",
      // livestart.current,
      // liveend.current
      // searchLocation.current
    ).then((result) => {
      setproducts(result);
      setUpdatelist(true);
      setdata(true);
      setreload(false);
    });
  }, [reload]);

  const rendertable = () => {
    if (reload) {
      return (
        <>
          <span style={{ marginTop: "30px" }}>
            <Spin indicator={antIcon} /> loading
          </span>
        </>
      );
    }
  };

  if (data) {
    // console.log(attributelist[1].terms);
    return (
      <>
        <Row>
          {/* <Col span={6}>
            <h3>Pick product live date</h3>
            <RangePicker
              style={{ width: "100%" }}
              picker="date"
              onChange={(value) => {
                if (value) {
                  livestart.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                  liveend.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                  setreload(true);
                }
              }}
            /></Col> */}
          <Col span={8}>
            <h3>Enter product title for instant Search</h3>
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6} >
            <h3>Category</h3>
            <TreeSelect
              style={{ width: "100%" }}
              treeData={categoryList}
              onChange={(value) => {
                pageno.current = 1;
                searchCategory.current = value;
                setreload(true);
              }}
            />
          </Col>
          <Col span={4}>
            <h3>Color</h3>
            <Select
              showSearch
              placeholder="Please pick a color"
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(value) => {
                pageno.current = 1;
                searchColor.current = value;
                setreload(true);
              }}
            >
              <Option value="">ALL</Option>
              {attributelist[1].terms.map((color) => {
                return <Option value={color.id}>{color.name}</Option>;
              })}
            </Select>
          </Col>
        </Row>
        <Divider />
        <Spin spinning={reload}>
          <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab="Active Products" key="1">
              <ActiveRenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
            <TabPane tab="Inactive Products" key="2">
              <RenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
          </Tabs>
        </Spin>
      </>
    );
  } else {
    return (
      <>
        <Skeleton active />
        <Skeleton active />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    List: state.singleProduct.sinleproductlist.results,
    totalitems: state.singleProduct.sinleproductlist.count,
    categoryList: state.category.categorylist,
    Location: state.warehouse.locationlist,
    attributelist: state.attribute.attributelist,
  };
};

export default connect(mapStateToProps, {
  getSingleProductbystatus,
  getAllCategory,
  getAllAttribute,
})(ProductList);
